import * as React from "react";
import { NocturneLoaderProperties } from "./nocturne-loader.properties";
import classNames from "classnames";
import moon from "./assets/moon.png";
import owl from "./assets/owl.png";
import owlEyes from "./assets/owl-eyes.png";
import styles from "./nocturne-loader.module.scss";

export class NocturneLoader extends React.PureComponent<NocturneLoaderProperties, {
    isReady: boolean;
    isExiting: boolean;
}> {
    private isComponentMounted = false;

    public constructor(props: NocturneLoaderProperties) {
        super(props);
        this.state = {
            isReady: false,
            isExiting: false,
        };
    }

    public componentDidMount(): void {
        this.isComponentMounted = true;

        setTimeout(
            () => {
                if (!this.isComponentMounted) {
                    return;
                }

                this.setState(
                    {
                        isReady: true,
                    },
                    () => this.onClick()
                );
            },
            5000
        );
    }

    public componentWillUnmount(): void {
        this.isComponentMounted = false;
    }

    public render(): React.ReactNode {
        return <section
            className={
                classNames(
                    styles.loader,
                    {
                        [styles.in]: this.props.isLoading,
                        [styles.out]: !this.props.isLoading,
                        [styles.mobile]: this.props.isMobile,
                    }
                )
            }
            onClick={this.onClick}
        >
            <span>
                <span>
                    <img className={styles.moon} src={moon} />
                    <img className={styles.owl} src={owl} />
                    <img className={styles["owl-eyes"]} src={owlEyes} />
                </span>
            </span>
            <h2>A NOCTURNE STUDIOS GAME</h2>
            <div
                className={
                    classNames(
                        {
                            [styles.out]: this.props.isLoaded,
                        }
                    )
                }
                style={{ ["--progress" as any]: `${this.props.percentage.toFixed(2)}%` }}
            />
            <h3
                className={
                    classNames(
                        {
                            [styles.in]: this.props.isLoaded && this.state.isReady,
                            [styles.out]: this.props.isLoaded && this.state.isReady && this.state.isExiting,
                        }
                    )
                }
            >PRESS TO PLAY</h3>
        </section>;
    }

    private onClick = () => {
        if (!this.props.isLoaded || !this.state.isReady || this.state.isExiting) {
            return;
        }

        this.setState(
            {
                isExiting: true,
            }
        );

        setTimeout(
            () => {
                if (!this.isComponentMounted) {
                    return;
                }

                this.props.onExit();
            },
            500
        );
    };
}
